const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl);
});

const alertList = document.querySelectorAll('.alert')
alertList.forEach(function (alert) {
  new bootstrap.Alert(alert);
});

const allOfferModal = Array.from(document.querySelectorAll('[data-modal-show]'));

allOfferModal.map(modal => {
	const allOfferModal = new bootstrap.Modal(modal, {
	  keyboard: false
	});

	setTimeout(() => {
		allOfferModal.show();
	}, modal.getAttribute('data-delay'));
});